import { Box, Text, VStack } from "@chakra-ui/react";
import React from "react";
import colors from "../../../app/colors";

const circlePx = 52;

/** Red tint for "off" states (mic muted, camera off), like Meet/Zoom. */
const offBackground = "rgba(233, 69, 69, 0.22)"; // colors.red @ 22%

export type CallBarItemProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  label: string;
  variant: "control" | "end";
  icon: React.ReactNode;
  /** Control is in its off/muted state: red-tinted circle with a red glyph. */
  isOff?: boolean;
};

export const CallBarItem: React.FC<CallBarItemProps> = ({
  label,
  variant,
  icon,
  isOff = false,
  disabled,
  type = "button",
  ...buttonProps
}) => {
  const isEnd = variant === "end";
  let bg: string = colors.gray40;
  let color = "#FFFFFF";
  if (isEnd) {
    bg = colors.red;
  } else if (isOff) {
    bg = offBackground;
    color = colors.red;
  }

  return (
    <VStack spacing="6px" flexShrink={0} align="center" minW={`${circlePx}px`}>
      <Box
        as="button"
        type={type}
        disabled={disabled}
        display="flex"
        alignItems="center"
        justifyContent="center"
        w={`${circlePx}px`}
        h={`${circlePx}px`}
        borderRadius="full"
        bg={bg}
        color={color}
        border="none"
        cursor={disabled ? "not-allowed" : "pointer"}
        opacity={disabled ? 0.45 : 1}
        transition="background 0.15s ease, color 0.15s ease, opacity 0.15s ease"
        _hover={
          disabled
            ? undefined
            : { filter: isEnd ? "brightness(1.08)" : "brightness(1.12)" }
        }
        _active={disabled ? undefined : { transform: "scale(0.97)" }}
        {...buttonProps}
      >
        {icon}
      </Box>
      <Text
        as="span"
        display="block"
        w="100%"
        textAlign="center"
        fontSize="11px"
        fontWeight={600}
        color={colors.gray30}
        fontFamily="Inter"
        userSelect="none"
        whiteSpace="nowrap"
      >
        {label}
      </Text>
    </VStack>
  );
};
